import { lastDayOfMonth, isFuture, isValid } from 'date-fns';

/**
 * Returns true if the given string represents an expired date.
 * Note that the month must have 2 digits, even for months whose numbers can be
 * represented by a single digit (ex: january would be 01, not 1).
 *
 * @param monthYearString - A string with the MM/yy format
 */
export default function creditCardExpired(monthYearString: string): boolean {
  // First, check if the provided string is valid
  if (!/^(0[1-9]|1[012])[/](\d\d)$/.exec(monthYearString)) {
    return true;
  }

  const [month, year] = monthYearString.split('/');
  const formattedString = `${month}/01/20${year}`;
  const dateToCompare = new Date(formattedString);
  if (isValid(dateToCompare)) {
    return !isFuture(lastDayOfMonth(dateToCompare));
  }
  return true;
}
